import { asyncRouterMap, constantRouterMap } from "@/config/router.config"
import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = -1
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.indexOf(permission[i])
      if (flag >= 0) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.indexOf(roles.id)
  } else {
    return true
  }
}

function filterAsyncRouter(routerMap, roles) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(roles.permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

function loadView(viewPath){
  return () => import(`@/views/${viewPath}`)
}

function filterDynamicRouter (routeList){  
  routeList.map((route) => {
    if (route.component) {
      if (route.component === 'TabLayout') {
        route.component = TabLayout
      } else {
        route.component = loadView(route.component)
      }
    }else{
      route.component = TabLayout
    }
    if (route.children && route.children.length) {
      route.children = filterDynamicRouter(route.children)
    }
  });  
  return routeList
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    routeList: []
  },
  mutations: {
    SET_ROUTERS: (state, data) => {
      state.addRouters = data
      state.routers = constantRouterMap.concat(data)
      //console.log('-----mutations---SET_ROUTERS----', data)
    },
    SET_ACTION_ARRAY: (state, info_array) => {
      let path = info_array.path
      let new_action_routers = info_array.routesTemplate
      state.all_action_array.push(path)
      state.new_action = new_action_routers
    },
    setRouteList(state, data) {
      state.routeList = filterDynamicRouter(data);      
      state.hasGetRoute = true
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        console.log('-----mutations---data----', data)
        let accessedRouters
        accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        console.log('-----mutations---accessedRouters----', accessedRouters)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    // 动态添加主界面路由，需要缓存
    UpdateAppRouter({ commit }, routes) {
      return new Promise(resolve => {
        //const [ roles ] = routes.constRoutes
        let routelist = routes.constRoutes;
        commit('SET_ROUTERS', routelist)
        resolve()
      })
    },
    /*动作路由*/
    getRouteList(store, params) {
      const { commit, dispatch, state, rootState } = store;
      return new Promise((resolve) => {
        let actionRouter = Vue.ls.get('actionRouter') || [];
        let isConcationsPath = actionRouter.some((item, index)=>{
          return item.path == params.path;
        });   
        let route = [
          {
            path: `/${params.name}`,
            name: params.name,
            meta: {title: ''},
            children: [
              {
                path: params.path,
                name: params.name,
                component: params.component,
                meta: {
                  title: params.meta.title
                }
              },
            ]
          },
        ]
        commit('setRouteList', route)
        resolve()
      })
    }
  }
}

export default permission